import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /finanzen. Reine Wrapper-Komponente — Inhalt liegt in
 * finanzen.bank.tsx etc. (L-13: Parent muss <Outlet /> rendern, nicht den
 * Inhalt selbst, sonst overshadowed das Parent die Children).
 */
export const Route = createFileRoute('/finanzen')({
  component: FinanzenLayout,
});

function FinanzenLayout() {
  return <Outlet />;
}
